<template>
  <div class="d-flex justify-center mt-8">
    <v-btn color="secondary" rounded @click="handleAddRow">
      <v-icon size="20">mdi-plus</v-icon>
      {{ $t("add_row") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-grid-rules-add-row-button",
  methods: {
    handleAddRow() {
      this.$emit("add-row");
    }
  }
};
</script>
